const viewSiteContent = {
  storeLocator: {
    findAStore: 'Find a Store',
    findStoreNearby: 'FIND STORE NEARBY',
    submit: 'SUBMIT',
    enableLocation: 'Enable your location and locate a store near you',
    distance: 'Distance',
    category: 'Category',
    product: 'Product',
    storesFound: 'Stores Found',
    miles: 'miles',
    allProducts: 'All <brand> Products',
    productType: 'All Products',
    noStoresFound: 'No Stores Found',
    narrowSearch: 'Narrow Your Search',
    apply: 'APPLY',
    custom: 'CUSTOM',
    customProducts: 'CUSTOMPRODUCTS',
    default: 'DEFAULT',
    full: 'FULL',
    or: 'Or',
    pinError: 'Please enter valid zip code.',
    categoryError: 'Please select category',
    productError: 'Please select product',
    locationDisabled: 'Location Disabled',
    locationMessage:
      'Please navigate to browsers settings to enable the location tracking for this website.',
    narrowYourSearch: 'Narrow your search',
    placeholderText: 'Zip/postal code',
    iconFilterTitle: 'Filter',
    iconSearchTitle: 'Search',
    categoryLabel: 'All Vanity Fair Products',
  },
  findDistributor: {
    findADistributor: 'Find a Distributor',
    findDistributorNearby: 'FIND DISTRIBUTOR NEARBY',
    submit: 'SEARCH',
    locationLabel: 'Enter Location',
    enableLocation: 'Enable your location and locate a store near you',
    list: 'List',
    searchRadius: 'Distance',
    productListDropDownLabel: 'Select Product List',
    productListLabel: 'Find Distributors from Product List',
    noProductListLabel: 'No Product List',
    createListLabel: 'Create Product List',
    messageIfNotLoggedIn:
      'Log In or Create an Account to search with your saved Product Lists',
    stockProductLabel: 'Only Display Distributors that Stock this Product ',
    stockProductListLabel:
      'Only Display Distributors that Stock Products in Selected Product List ',
    inListText: 'Only Display Distributrs that Stock Products In Selected List',
    narrowYourSearch: 'Narrow your search',
    locationDisabled: 'Location Disabled',
    locationMessage:
      'Please navigate to browsers settings to enable the location tracking for this website.',
    or: 'Or',
    noDistributorFound: 'No Distributors Found',
    locationPLaceHolder: 'Search by <city, zip/postal code>',
    locationPLaceHolderMobile: '<city, zip/postal code>',
    distributorsFound: 'Distributors Found',
    locationTextError: 'Please enter in a valid City, State or Zip Code',
    permissionDeniedError:
      'Please enable your location permissions within your browser to locate a Distributor near you',
    mfgNumber: 'MFG#',
    itemNumber: 'ITEM ID#',
    custNumber: 'CUST#',
    searchCriteriaError: 'Please enter in a valid search criteria',
  },

  bannerCarousel: {
    carouselControlPrevious: 'Previous',
    carouselControlNext: 'Next',
    iconChevronLeftTitle: 'Left',
    iconChevronRightTitle: 'Right',
  },
  featureProduct: {
    iconPlayTitle: 'Play',
  },
  heroBanner: {
    iconPlayTitle: 'Play',
  },
  imageTile: {
    iconPlayTitle: 'Play',
  },
  imageTitle: {
    iconPlayTitle: 'Play',
  },
  productSolution: {
    iconPlayTitle: 'Play',
  },
};

export default viewSiteContent;



// WEBPACK FOOTER //
// ./src/locale/view-site-content-i18n.js